// let apiaddr = '/api'  // npm run serve 用
// let apiaddr = 'https://admin1.bridgenebio.com' // npm run build 用
let apiaddr = process.env.VUE_APP_ADMIN_API // npm run build 用
console.log("apiaddr: ", apiaddr)
export {
  apiaddr
}
